import React, { useState } from 'react';
import GoogleBusinessSearch from './components/GoogleBusinessSearch';
import StepperForm from './components/Stepper/StepperForm'; // Az új komponens, amit meg akarsz jeleníteni
import 'primereact/resources/themes/lara-light-blue/theme.css';
import 'primereact/resources/primereact.min.css';
import 'primeicons/primeicons.css';
import 'primeflex/primeflex.min.css';
import 'primeflex/themes/primeone-light.css';
import './styles.scss';

const App: React.FC = () => {
  const [selectedBusiness, setSelectedBusiness] = useState<any | null>(null); // Itt tároljuk a kiválasztott adatokat

  return (
    <div
      style={{
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'center',
        minHeight: '80vh',
      }}
    >
      <h1 className="text-center">Üdvözöljük az Onboarding Oldalunkon</h1>

      {!selectedBusiness ? (
        <GoogleBusinessSearch onBusinessSelect={setSelectedBusiness} />
      ) : (
        <StepperForm business={selectedBusiness} />
      )}
    </div>
  );
};

export default App;
